var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:{
    'goal-inline-menubar': true,
    'is-selected':         _vm.selected
  },attrs:{"to":'/goal/' + _vm.goalId + '/dashboard'}},[_c('div',{staticClass:"menubar-goal__picture"},[_c('div',{staticClass:"goal-inline-menubar-image",style:(_vm.background_image_css)})]),_c('div',{staticClass:"menubar-goal__name"},[_vm._v("\n    "+_vm._s(_vm.goal_meta.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }